module.exports = __webpack_public_path__ + "static/media/Snoman title.ea1f0722.png";